import client from '../request'

const getAll = `categories`

const get = (id) => {
  return `/categories/${id}`
}

const create = (data) => {
  return client.post('/categories', data)
}

const update = (id, data) => {
  return client.put(`/categories/${id}`, data)
}

const remove = (id, data) => {
  return client.delete(`/categories/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const CategoryService = {
  getAll,
  get,
  create,
  update,
  toRow,
  toPaginate,
  remove
}

export default CategoryService
